import React, {useEffect, useState, Fragment} from 'react';
import useStyles from "../../styles/styles";
import {
    Box, Button,
    Chip,
    Container,
    CircularProgress,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    IconButton,
    Grid,
    makeStyles,
    Modal,
    Paper,
    Typography, TextField
} from "@material-ui/core";
import {Alert, AlertTitle, Autocomplete} from '@material-ui/lab';
import {useLazyQuery} from "@apollo/react-hooks";
import AddBoxIcon from '@material-ui/icons/AddBox';
import AlarmAdd from '@material-ui/icons/AlarmAdd';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ScheduleIcon from '@material-ui/icons/Schedule';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import RenderInput from "../TrafficSource/RenderInput";
import { baseFields, availablityFields } from "../../utils/ScheduleFields";
import useFormInputs from "../../hooks/useFormInputs";
import _ from 'lodash';
import theme from "../../styles/theme";
import setTime from "../../utils/setTime";
import {gql} from "apollo-boost";
import ConfigFields from "./ConfigFields";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {base16AteliersulphurpoolLight} from "react-syntax-highlighter/dist/cjs/styles/prism";

const useScheduleStyles = makeStyles({
    root: {
        border: '1px solid',

        '& .MuiExpansionPanelSummary-root': {
            padding: theme.spacing(0, 2, 0, 1),
        },
    },
    removeButton: {
        cursor: 'pointer',
        pointerEvents: 'all'
    },
    timePanel: {
        '& .MuiBox-root': {
            paddingRight: theme.spacing(1)
        }
    }
});

const ConfigScheduleModal = ({ data, modalData, closeModal }) => {
    const classes = useStyles();
    const scheduleClasses = useScheduleStyles();
    const [dayFields, setDayFields] = useState([]);
    const [expandedPanelsArr, setExpandedPanelsArr] = useState([]);
    const [view, setView] = useState('');
    const [id, setId] = useState('');
    const [importType, setImportType] = useState('');
    const [error, setError] = useState(false);
    const [multipleSchedules, setMultipleSchedules] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const formatFinal = (type) => {
        let arr = [];
        dayFields.forEach(days => {
            let obj = {};
            days.forEach(item => {
                const { key, value, ranges } = item;
                obj = {
                    [key] : value,
                    ranges: []
                };
                ranges.forEach(timeRange => {
                    let timeObj = {};
                    timeRange.forEach(time => {
                        timeObj = {
                            ...timeObj,
                            [time.key] : time.value
                        };
                    });
                    obj.ranges.push(timeObj);
                });
            });
            if (obj.dayOfWeek && obj.ranges.length) {
                arr.push(obj);
            } else {
                if (type === 'finalObj'){
                    setError(true);
                }
            }
        });
        return arr;
    };
    const onSubmit = () => {
        let isError = false;
        setSubmitLoading(true);
        setError(false);
        const finalObj = {
            name: inputs.name,
            timeZone: inputs.timeZone,
            available: [],
            federalObservances: [],
        };

        if (inputs.federalObservances && inputs.federalObservances.length) {
            finalObj.federalObservances = inputs.federalObservances.map(item => {
               return _.has(item, 'name') ? item.name : item;
            });
        }
        /*
            Looping Through the days to create the object
        */
        let arr = [];
        if (dayFields.length) {
            arr = formatFinal('finalObj');
        } else {
            isError = true;
        }
        // Set Objects for Graphql
        if (arr.length) {
            finalObj.available = arr;
        }
        let newValue = finalObj;
        const newData = {
            key: inputs.key,
            category: inputs.category,
        };
        // Check if Any fields are blank
        Object.keys(newData).forEach(key => {
            const value = newData[key]
            if (value === '') {
                isError = true;
            }
        });
        if (finalObj.name === '' || finalObj.timeZone === ''){
            isError = true
        }
        // Save Data to GraphQL
        if (modalData.data.id) {
            newData.id = modalData.data.id;
        }
        if (!isError) {
            if (modalData.showAddRow) {
                newValue = JSON.stringify(finalObj);
                modalData.triggerCreate(newValue, newData);
            } else {
                modalData.triggerUpdate(newValue, newData);
            }
        }  else {
            setError(true);
            setSubmitLoading(false);
        }
    };
    const {inputs, handleInputChange, handleFilterChange, handleSwitchChange, handleSubmit, setInputs} = useFormInputs(onSubmit);

    const setScheduleData = (obj) => {
        const { name, timeZone, available, federalObservances} = obj;
        setInputs(inputs => ({
            ...inputs,
            name,
            timeZone,
            federalObservances,
        }));

        if (available.length) {
            let finalArr = [];
            available.forEach((item, idx) => {
                const { ranges } = item;
                let obj = {};
                availablityFields.forEach(day => {
                    obj = {
                        ...day,
                        value: item.dayOfWeek,
                        ranges: []
                    };
                    ranges.forEach(time => {
                        let newRange = [];
                        Object.keys(time).forEach(timeKey => {
                            let timeSchedule;
                            if(timeKey !== '__typename') {
                                const field = day.ranges.filter(item => item.key === timeKey);
                                if (field.length) {
                                    timeSchedule = {
                                        ...field[0],
                                        value: time[timeKey]
                                    };
                                }
                                newRange.push(timeSchedule);
                            }
                        });
                        if (newRange.length){
                            const sortedMap = _.orderBy(newRange, ['key'],['desc']);
                            obj.ranges.push(sortedMap);
                        }
                    });
                });
                finalArr.push([obj]);
            });
            setView('schedule')
            setDayFields(finalArr);
        }
    };

    useEffect(() => {
        if (modalData) {
            if (modalData.value) {
                setScheduleData(modalData.value);
            } else {
                baseFields.arr.forEach(item => {
                    const value = item.key === 'federalObservances' ? [] : '';
                    setInputs(inputs => ({
                        [item.key]: value
                    }));
                });

                if (modalData.showAddRow) {
                    setView('option');
                }
            }
            setInputs(inputs => ({
                ...inputs,
                key: modalData.data.key || '',
                category: modalData.data.category || '',
                type: modalData.data.type || ''
            }));
        }
    }, [modalData]);

    const [runQuery, {loading, data: scheduleData}] = useLazyQuery(gql`
        query ImportSchedules(
            $campaignId: String!
            $servicerId: String!
            $portfolioId: String!
        ) {
            campaign(id: $campaignId) {
                id
                name
                filterAttributes(campaignOnly: true) {
                    hierarchyLevel
                    type
                    description
                    attributeType
                }
                schedules {
                    name
                    timeZone
                    federalObservances
                    available {
                        dayOfWeek
                        ranges {
                            closing
                            opening
                        }
                    }
                }
            }
            servicer(id: $servicerId) {
                id
                name
                schedules {
                    name
                    timeZone
                    federalObservances
                    available {
                        dayOfWeek
                        ranges {
                            opening
                            closing
                        }
                    }
                }
            }
            portfolio(id: $portfolioId) {
                id
                name
                schedules {
                    name
                    timeZone
                    federalObservances
                    available {
                        dayOfWeek
                        ranges {
                            opening
                            closing
                        }
                    }
                }
            }
        }
    `);

   useEffect(() => {
       if (scheduleData) {
           let importedSchedules = [];
           const { servicer, campaign, portfolio } = scheduleData;
           if (importType === 'Servicer') {
               if (servicer && servicer.schedules.length) {
                   importedSchedules = servicer.schedules;
               } else {
                   setError(true);
               }
           } else if (importType === 'Portfolio') {
                if (portfolio && portfolio.schedules.length) {
                    importedSchedules = portfolio.schedules;
                } else {
                    setError(true);
                }
           } else if (importType === 'Campaign') {
               if (campaign && campaign.schedules.length) {
                   importedSchedules = campaign.schedules;
               } else {
                   setError(true);
               }
           }
           // Set Schedules
           if (importedSchedules.length === 1) {
               setScheduleData(importedSchedules[0]);
           } else {
               setMultipleSchedules(importedSchedules);
           }
       }
   }, [scheduleData]);

    const addSchedule = (index, dayIdx) => {
      const values = [...dayFields];
      const day = values[index];
      if (day.length) {
          day[dayIdx].ranges.push([...availablityFields[0].ranges]);
          values[index] = day;
      }
      setDayFields(values);
    };

    const deleteSchedule = (index, dayIdx, deleteIndex) => {
        const values = [...dayFields];
        const day = values[index];
        if (day.length){
            const ranges = day[dayIdx].ranges.filter((item, index) => index !== deleteIndex);
            day[dayIdx].ranges = [...ranges];
        }
       setDayFields(values);
    };

    const handleScheduleChange = (index, dayIdx, timeIdx, keyIdx, newVal) => {
      const values = [...dayFields];
      const day = [...values[index]];
      if (day.length) {
          const newRanges = [...day[dayIdx].ranges];
          newRanges[timeIdx][keyIdx] = {
              ...newRanges[timeIdx][keyIdx],
              value: newVal
          };
          day[dayIdx] = {
              ...day[dayIdx],
              ranges: [...newRanges]
          };
          values[index] = [...day];
      }
      setDayFields(values);
    };

    const addDayRow = () => {
        const values = [...dayFields];
        const newSet = availablityFields.map(item => {
            return {
                ...item,
                ranges: []
            };
        });
        values.push(newSet);
        setDayFields(values);
    };

    const deleteDayRow = (deleteIndex) => {
        const values = dayFields.filter((item, index) => index !== deleteIndex)
        setDayFields(values);
    };

    const handleDayChanges = (idx, dayIdx, newVal) => {
        let values = [...dayFields];
        const obj = [...values[idx]];
        obj[dayIdx] = {
            ...obj[dayIdx],
            value: newVal
        };
        values[idx] = [...obj];
        setDayFields(values);
    };

    const copyEntireDay = (copyIndex) => {
        const values = [...dayFields];
        const currentDay = dayFields.filter((item, index) => index === copyIndex);
        if (currentDay.length) {
            const newObj = [JSON.parse(JSON.stringify(currentDay[0]))];
            newObj[0][0].value = '';
            values.push(newObj[0]);
            setDayFields(values);
        }
    };

    const copyTimeRange = (dayIdx, timeIndex) => {
        const values = [...dayFields];
        const currentDay = values[dayIdx];
        if (currentDay.length) {
            const obj = [JSON.parse(JSON.stringify(currentDay))];
            const ranges = obj[0][0].ranges;
            const copyRange = [JSON.parse(JSON.stringify(ranges[timeIndex]))];
            ranges.push(copyRange[0]);
            obj[0][0].ranges = ranges;
            values[dayIdx] = obj[0];
            setDayFields(values);
        }
    };
    const maxDays = data && dayFields.length === data.allDays.enumValues.length;

    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                       Build the Schedule Below.
                    </Typography>
                    {error && view === 'schedule' ? (
                        <Alert severity="error" style={{ marginBottom: '10px'}}>Please add values to the highlighted fields!</Alert>
                    ) : false}
                    {loading ? (
                        <CircularProgress color="inherit"/>
                    ) : null}
                    {view === 'import' ? (
                        <Box>
                            <Box
                                display={"flex"}
                                alignItems={"center"}
                                flexDirection={"column"}
                                style={{margin: '10px 0'}}
                                justifyContent={"center"}
                            >
                                {!multipleSchedules.length ? (
                                    <>
                                        {scheduleData && error ? (
                                            <Box style={{ margin: '10px 0'}}>
                                                <Alert severity="error">
                                                    <AlertTitle>{importType}</AlertTitle>
                                                    Please check the id since it's not returning any data or schedules.
                                                </Alert>
                                            </Box>
                                        ) : (
                                            <Box>
                                                <Alert severity="warning">Please select the type and id to import the schedule!</Alert>
                                            </Box>
                                        )}
                                    </>
                                ) : null}
                                {!multipleSchedules.length ? (
                                    <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        flexDirection={"row"}
                                        style={{margin: '10px 0'}}
                                        justifyContent={"center"}
                                    >
                                        <Box style={{ marginRight: '10px'}}>
                                            <Autocomplete
                                                size="medium"
                                                fullwidth
                                                className={classes.autoComplete}
                                                value={importType || ''}
                                                onChange={(event, value) => {
                                                    setError(false);
                                                    setImportType(value ? value.name : '');
                                                }}
                                                getOptionLabel={option => option.name || option}
                                                options={[{ name: 'Servicer'}, { name: 'Portfolio'}, { name: 'Campaign'}]}
                                                renderInput={
                                                    params =>
                                                        <TextField
                                                            {...params}
                                                            label="Type"
                                                            fullWidth
                                                            error={!importType}
                                                        />
                                                }
                                            />
                                        </Box>
                                        <Box>
                                            <RenderInput
                                                item={{
                                                    label: 'Id',
                                                    key: 'id',
                                                    type: 'text',
                                                    required: false
                                                }}
                                                value={id || ''}
                                                data={data}
                                                disabled={importType === ''}
                                                handleFilterChange={handleFilterChange}
                                                handleInputChange={(e) => {
                                                    setId(e.target.value);
                                                }}
                                                handleSwitchChange={handleSwitchChange}
                                            />
                                        </Box>
                                    </Box>
                                ) : (
                                    <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        flexDirection={"column"}
                                        style={{margin: '10px 0'}}
                                        justifyContent={"center"}
                                    >
                                        <Box>
                                            <Alert severity="success"> We have found {multipleSchedules.length} schedules, please click the button next to the schedule you wish to import.</Alert>
                                        </Box>
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            flexDirection={"column"}
                                            style={{margin: '10px 0', width: '100%'}}
                                            justifyContent={"center"}
                                        >
                                            {multipleSchedules.map(item => {
                                                return (
                                                    <Box
                                                        display={"flex"}
                                                        alignItems={"center"}
                                                        flexDirection={"row"}
                                                        style={{margin: '10px 0', width: '100%'}}
                                                        justifyContent={"space-between"}
                                                        key={item.name}
                                                    >
                                                        <Box>
                                                            <Typography variant="h6">
                                                                {item.name}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => {
                                                                    setScheduleData(item);
                                                                }}
                                                            >
                                                                Import Schedule
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                            <Box
                                display={"flex"}
                                alignItems={"center"}
                                style={{margin: '10px 0'}}
                                justifyContent={"center"}>
                                {!multipleSchedules.length ? (
                                    <Box style={{marginRight: '10px'}}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={id === ''}
                                            onClick={() => {
                                                setError(false);
                                                const variables = {
                                                    campaignId: '',
                                                    servicerId: '',
                                                    portfolioId: ''
                                                };
                                                variables[`${importType.toLowerCase()}Id`] = id;
                                                runQuery({
                                                    variables: {
                                                        ...variables
                                                    }
                                                });
                                            }}
                                        >
                                            Import
                                        </Button>
                                    </Box>
                                ) : null}
                                <Box style={{marginRight: '10px'}}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            setView('schedule');
                                        }}
                                    >
                                        Manually Enter Schedule
                                    </Button>
                                </Box>
                                <Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            closeModal();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    ) : null}
                    {view === 'option' ? (
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            style={{margin: '10px 0'}}
                            justifyContent={"center"}>
                            <Box style={{marginRight: '10px'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                       setView('import');
                                    }}
                                >
                                    Import from Existing
                                </Button>
                            </Box>
                            <Box style={{marginRight: '10px'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setView('schedule');
                                    }}
                                >
                                    Manually Enter Schedule
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        closeModal();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Box>
                    ) : null}
                    {/* Schedule Builder */}
                    {view === 'schedule' ? (
                        <>
                            <ConfigFields
                                inputs={inputs}
                                setInputs={setInputs}
                                data={data}
                                modalData={modalData}
                            />
                            <Grid container spacing={3} style={{margin: '3px -12px 5px'}}>
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        <Box display="flex" flexDirection="row" alignItems="center">
                                            <strong>Schedule Fields</strong>
                                        </Box>
                                    </Typography>
                                </Grid>
                                {baseFields.arr.map(item => {
                                    const { key, fullWidth } = item;
                                    const colWidth = fullWidth ? 12 : 6;
                                    return (
                                      <Grid key={key} item xs={colWidth}>
                                          <RenderInput
                                              item={item}
                                              value={inputs[key] || ''}
                                              data={data}
                                              handleFilterChange={(newVal) => {
                                                  setInputs(inputs => ({
                                                      ...inputs,
                                                      [key]: newVal || ''
                                                  }));
                                              }}
                                              handleInputChange={handleInputChange}
                                              handleSwitchChange={handleSwitchChange}
                                          />
                                      </Grid>
                                    );
                                })}
                            </Grid>
                            <Grid container spacing={3} style={{marginBottom: '5px'}}>
                                <Grid container direction="row" alignItems="center" spacing={2} style={{ padding: '5px 12px'}}>
                                    <Grid item xs={1}>
                                        <Typography variant="body1">
                                            <Box display="flex" flexDirection="row" alignItems="center">
                                                <strong>Availablity</strong>
                                            </Box>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            onClick={() => addDayRow()}
                                            size="small"
                                            disabled={maxDays}
                                        >
                                            <CalendarTodayIcon />
                                            <AddBoxIcon/>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={9}>
                                        {dayFields.map((days, idx) => (
                                            <Fragment key={idx.toString()}>
                                                {days.map((item, dayIdx) => (
                                                    <Chip
                                                        style={{ marginRight: '5px' }}
                                                        key={dayIdx.toString()}
                                                        label={days[dayIdx].value || 'Not Set'}
                                                        onDelete={(e) => {
                                                            e.stopPropagation();
                                                            deleteDayRow(idx);
                                                        }}
                                                        deleteIcon={<RemoveCircleIcon />}
                                                    />
                                                ))}
                                            </Fragment>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid container style={{ height: '400px', overflow:'scroll'}}>
                                    <Grid item xs={9} id="schedule-container">
                                        {!dayFields.length ? (
                                            <Alert severity="error" style={{ marginBottom: '10px'}}>
                                                Please add at least one day to save this schedule!
                                            </Alert>
                                        ) : null}
                                        {error && (
                                            <Alert severity="error" style={{ marginBottom: '10px'}}>
                                                Please make sure all panels did not have any errors!
                                            </Alert>
                                        )}
                                        {dayFields.map((days, idx) => {
                                            const isExpanded = expandedPanelsArr.length ? expandedPanelsArr.includes(idx) : false;
                                            return (
                                                <ExpansionPanel
                                                    id={`schedule-${idx}`}
                                                    expanded={isExpanded}
                                                    className={scheduleClasses.root}
                                                    key={idx.toString()}
                                                    onChange={(e, bool) => {
                                                        if (bool) {
                                                            setExpandedPanelsArr(expandedPanelsArr => [...expandedPanelsArr, idx]);
                                                        } else {
                                                            if (expandedPanelsArr.includes(idx)) {
                                                                setExpandedPanelsArr(expandedPanelsArr.filter(panel => panel !== idx));
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <ExpansionPanelSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                    >
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={3}
                                                        >
                                                            {days.map((item, dayIdx) => {
                                                                const {key, ranges} = item;
                                                                const panelDay = days[dayIdx].value || false;
                                                                return (
                                                                    <Grid container key={dayIdx.toString()} style={{ margin: '10px 0'}}>
                                                                        <Grid item xs={12} md={3}>
                                                                            <Box display="flex" flexDirection="row" alignItems="center">
                                                                                <Box display="flex" flexDirection="column" alignItems="center">
                                                                                    <IconButton
                                                                                        className={scheduleClasses.removeButton}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            deleteDayRow(idx);
                                                                                        }}>
                                                                                        <RemoveCircleIcon/>
                                                                                    </IconButton>
                                                                                    {!maxDays ? (
                                                                                        <IconButton
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                copyEntireDay(idx);
                                                                                            }}>
                                                                                            <FileCopyIcon/>
                                                                                        </IconButton>
                                                                                    ) : null}
                                                                                </Box>
                                                                                <Box textAlign="left">
                                                                                    {panelDay? (
                                                                                        <Typography variant="h6" style={{ margin: 0}}>
                                                                                            {panelDay}
                                                                                        </Typography>
                                                                                    ) : null}
                                                                                    {isExpanded && (!ranges.length || !panelDay) ? (
                                                                                        <Alert severity="error">
                                                                                            Missing required data!
                                                                                        </Alert>
                                                                                    ) : null}
                                                                                    <Typography variant="caption">
                                                                                        {isExpanded ? 'Close Schedule' : 'Edit Schedule'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </Grid>
                                                                        {!isExpanded ? (
                                                                            <Grid item xs={12} md={9}>
                                                                                {!ranges.length || !panelDay ? (
                                                                                    <Alert severity="error" style={{ marginBottom: '10px'}}>
                                                                                        Please make sure this panel has a day of the week and at least one opening and closing schedule.
                                                                                    </Alert>
                                                                                ) : null}
                                                                                {ranges.map((timeRange, timeIdx) => {
                                                                                   return (
                                                                                        <Grid item xs={12} key={timeIdx} style={{ marginBottom: '10px'}}>
                                                                                            <Alert
                                                                                                icon={<ScheduleIcon fontSize="inherit" />}
                                                                                                severity="success"
                                                                                            >
                                                                                                <Box display={"flex"} flexDirection="row" alignItems="center" className={scheduleClasses.timePanel}>
                                                                                                    <Box>
                                                                                                        <Typography variant={"body1"}>
                                                                                                            <strong>Schedule {timeIdx + 1} - </strong>
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                    {timeRange.map((time, keyIdx) => {
                                                                                                        const item = days[dayIdx].ranges[timeIdx][keyIdx];
                                                                                                        return (
                                                                                                            <Box key={keyIdx}>
                                                                                                                <Typography variant={"body1"}>
                                                                                                                    <strong>{item.label}: </strong>
                                                                                                                    {item.value ? setTime(item.value) : 'N/A'}
                                                                                                                </Typography>
                                                                                                            </Box>
                                                                                                        );
                                                                                                    })}
                                                                                                </Box>
                                                                                            </Alert>
                                                                                        </Grid>
                                                                                    );
                                                                                })}
                                                                            </Grid>
                                                                        ) : null}
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails className={classes.details}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={3}
                                                            style={{ margin: '10px 0'}}
                                                        >
                                                            {days.map((item, dayIdx) => {
                                                                const { key, ranges } = item;
                                                                return (
                                                                    <Grid
                                                                        key={key}
                                                                        container
                                                                        direction="row"
                                                                        alignItems="center"
                                                                        spacing={3}
                                                                        style={{ padding: '5px 12px'}}
                                                                    >
                                                                        <Grid container spacing={2} direction="row" alignItems="center">
                                                                            <Grid item xs={4}>
                                                                                <RenderInput
                                                                                    item={item}
                                                                                    value={days[dayIdx].value || ''}
                                                                                    data={data}
                                                                                    handleFilterChange={(newVal) => handleDayChanges(idx, dayIdx, newVal)}
                                                                                    handleInputChange={handleInputChange}
                                                                                    handleSwitchChange={handleSwitchChange}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={8}>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    className={classes.addButton}
                                                                                    onClick={() => addSchedule(idx, dayIdx)}
                                                                                    size="small"
                                                                                >
                                                                                    <AlarmAdd />
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid container spacing={2} style={{ margin: '10px 0'}}>
                                                                            {ranges.map((timeRange, timeIdx) => (
                                                                                <Grid item xs={6} key={timeIdx}>
                                                                                    <Box
                                                                                        display={"flex"}
                                                                                        flexDirection="row"
                                                                                        alignItems="center"
                                                                                        className={scheduleClasses.timePanel}
                                                                                    >
                                                                                        {timeRange.map((time, keyIdx) => {
                                                                                            const value = days[dayIdx].ranges[timeIdx][keyIdx].value;
                                                                                            return (
                                                                                                <Box key={`${dayIdx}_${keyIdx}`}>
                                                                                                    <RenderInput
                                                                                                        item={time}
                                                                                                        value={value || ''}
                                                                                                        data={data}
                                                                                                        handleFilterChange={handleFilterChange}
                                                                                                        handleInputChange={(e) => handleScheduleChange(idx, dayIdx, timeIdx, keyIdx, e.target.value)}
                                                                                                        handleSwitchChange={handleSwitchChange}
                                                                                                    />
                                                                                                </Box>
                                                                                            );
                                                                                        })}
                                                                                        <Box>
                                                                                            <IconButton
                                                                                                onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    copyTimeRange(dayIdx, timeIdx);
                                                                                                }}>
                                                                                                <FileCopyIcon/>
                                                                                            </IconButton>
                                                                                        </Box>
                                                                                        <Box>
                                                                                            <Button
                                                                                                variant="contained"
                                                                                                className={classes.deleteButton}
                                                                                                onClick={() => deleteSchedule(idx, dayIdx, timeIdx)}
                                                                                                size="small"
                                                                                            >
                                                                                               <DeleteIcon />
                                                                                            </Button>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Grid>
                                                                            ))}
                                                                        </Grid>
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            );
                                        })}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                                            <Typography variant="body1">
                                                <strong>JSON Schedule Preview</strong>
                                            </Typography>
                                        </Box>
                                        <Box style={{ height: '800px', overflow: 'scroll'}}>
                                            <SyntaxHighlighter language="json" style={base16AteliersulphurpoolLight}>
                                                {JSON.stringify(formatFinal('json'), null, 1)}
                                            </SyntaxHighlighter>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Box
                                display={"flex"}
                                alignItems={"center"}
                                style={{margin: '10px 0'}}
                                justifyContent={"center"}>
                                <Box style={{marginRight: '10px'}}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={submitLoading || inputs.timeZone === '' || inputs.name === '' || (inputs.available && inputs.available.length)}
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                    >
                                        {submitLoading ? (
                                            <CircularProgress color="inherit"/>
                                        ) : (
                                            <>
                                                Save Values
                                            </>
                                        )}
                                    </Button>
                                </Box>
                                <Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            closeModal();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </>
                    ) : null}
                </Paper>
            </Container>
        </Modal>
    );
};

export default ConfigScheduleModal;
